export type BusinessDomain = 'LENDING' | 'CAPITALS';

export const BUSINESS_DOMAIN_STORAGE_KEY = 'whatzneu_business_domain';

export const BUSINESS_DOMAINS: { id: BusinessDomain; label: string; description: string }[] = [
  { id: 'LENDING', label: 'Lending', description: 'Loans, collections & finance ops' },
  { id: 'CAPITALS', label: 'Capitals', description: 'Investment picks & portfolio' },
];

export const DOMAIN_DEFAULT_ROUTES: Record<BusinessDomain, string> = {
  LENDING: '/admin/dashboard',
  CAPITALS: '/admin/capitals/stock-picks',
};

export function isCapitalsRoute(pathname: string): boolean {
  return pathname.startsWith('/admin/capitals')
    || pathname.startsWith('/admin/icici-breeze')
    || pathname.startsWith('/admin/stock-registry')
    || pathname.startsWith('/admin/networth');
}

export function domainForPath(pathname: string): BusinessDomain {
  return isCapitalsRoute(pathname) ? 'CAPITALS' : 'LENDING';
}

export interface AdminNavItem {
  id: string;
  label: string;
  iconName: string;
  color: string;
  subLabel: string;
  domains: BusinessDomain[];
}

export const ADMIN_NAV_ITEMS: AdminNavItem[] = [
  { id: '/admin/dashboard', label: 'Dashboard', iconName: 'Analytics', color: '#4CAF50', subLabel: 'Business Overview', domains: ['LENDING'] },
  { id: '/admin/customers', label: 'Customers', iconName: 'People', color: '#2196F3', subLabel: 'Manage Clients', domains: ['LENDING'] },
  { id: '/admin/blacklisted-customers', label: 'Blacklisted', iconName: 'Block', color: '#B71C1C', subLabel: 'Written-off / blocked borrowers', domains: ['LENDING'] },
  { id: '/admin/eligibility-check', label: 'Eligibility', iconName: 'FactCheck', color: '#1565C0', subLabel: 'Blocklist check by email / mobile', domains: ['LENDING'] },
  { id: '/admin/deposits-monitoring', label: 'Deposits', iconName: 'Savings', color: '#00897B', subLabel: 'Report & audit trail', domains: ['LENDING'] },
  { id: '/admin/whatsapp-payment-reminders', label: 'WA Reminders', iconName: 'WhatsApp', color: '#25D366', subLabel: 'Approve & send payment reminders', domains: ['LENDING'] },
  { id: '/admin/leads', label: 'Leads', iconName: 'ContactMail', color: '#00BCD4', subLabel: 'Loan Applications', domains: ['LENDING'] },
  { id: '/admin/products', label: 'Products', iconName: 'Inventory', color: '#FF9800', subLabel: 'Manage Products', domains: ['LENDING'] },
  { id: '/admin/payments', label: 'Payments', iconName: 'Payment', color: '#4CAF50', subLabel: 'All Payments & Debits', domains: ['LENDING'] },
  { id: '/admin/monthly-payment-transactions', label: 'Monthly Txn Summary', iconName: 'CalendarMonth', color: '#5C6BC0', subLabel: 'Transactions by month (till today)', domains: ['LENDING'] },
  { id: '/admin/customer-lending-audit', label: 'Lending audit', iconName: 'Assessment', color: '#455A64', subLabel: 'INTEREST vs short-term, expected interest', domains: ['LENDING'] },
  { id: '/admin/capital-efficiency', label: 'Capital efficiency', iconName: 'Speed', color: '#1B5E20', subLabel: 'CE% ranking & allocation suggestions', domains: ['LENDING'] },
  { id: '/admin/monthly-capital-efficiency', label: 'Monthly CE (MCE)', iconName: 'Timeline', color: '#00695C', subLabel: 'Monthly snapshots, trends & flags', domains: ['LENDING'] },
  { id: '/admin/financial-summary', label: 'Financial Summary', iconName: 'AccountBalance', color: '#009688', subLabel: 'Annual Revenue & Balance Sheet', domains: ['LENDING'] },
  { id: '/admin/monthly-kpi-snapshots', label: 'Monthly KPIs', iconName: 'ShowChart', color: '#3949AB', subLabel: 'Month-end snapshots & trends', domains: ['LENDING'] },
  { id: '/admin/revenue-cashflow', label: 'Revenue by Customer', iconName: 'Receipt', color: '#FF9800', subLabel: 'Revenue & Cashflow Report', domains: ['LENDING'] },
  { id: '/admin/interest-collected-month', label: 'Interest This Month', iconName: 'TrendingUp', color: '#3F51B5', subLabel: 'Interest by Customer (till today)', domains: ['LENDING'] },
  { id: '/admin/interest-requests', label: 'Interest Requests', iconName: 'Favorite', color: '#E91E63', subLabel: 'Customer Interests', domains: ['LENDING'] },
  { id: '/admin/capitals/stock-picks', label: 'Stock Picks', iconName: 'CandlestickChart', color: '#E65100', subLabel: 'Investment thesis & review', domains: ['CAPITALS'] },
  { id: '/admin/capitals/partners', label: 'Capital Partners', iconName: 'Groups', color: '#2E7D32', subLabel: 'Partner funding (not lending deposits)', domains: ['CAPITALS'] },
  { id: '/admin/icici-breeze', label: 'ICICI Breeze', iconName: 'CurrencyExchange', color: '#1565C0', subLabel: 'Portfolio & collateral (NSE)', domains: ['CAPITALS'] },
  { id: '/admin/stock-registry', label: 'Stock Registry', iconName: 'ShowChart', color: '#00897B', subLabel: 'NSE/BSE master & analysis', domains: ['CAPITALS'] },
  { id: '/admin/networth', label: 'Net worth', iconName: 'AccountBalanceWallet', color: '#6A1B9A', subLabel: 'Personal assets & snapshots', domains: ['CAPITALS'] },
  { id: '/admin/settings', label: 'Settings', iconName: 'Settings', color: '#9C27B0', subLabel: 'Account Settings', domains: ['LENDING', 'CAPITALS'] },
];

export function navItemsForDomain(domain: BusinessDomain): AdminNavItem[] {
  return ADMIN_NAV_ITEMS.filter((item) => item.domains.includes(domain));
}
